export function sHtml(context, prop) {
  context.htmlStatment = {
    value: prop.value,
  };
}
